export default "__VITE_ASSET__DcxwxXsC__"